import React from 'react';

import Sidebar from 'client/common/components/sidebar';
import { ISidebarOwnProps } from 'client/common/components/sidebar/sidebar';

import './index.css';

export default (props: ISidebarOwnProps) => <Sidebar withScrollHandling {...props} />;
